<ng-container *ngIf="!compact">
    <h4 class="small-page-title">Two-Factor Authentication</h4>
    <p>
        Increase the security of your account by requiring an additional code to be entered when logging in.
    </p>
</ng-container>

<div class="two-factor-cards" [class.two-factor-cards--compact]="compact">
    <div class="card" [class.highlight-2fa]="highlight2fa && !isGoogleAuthEnabled">
        <div class="card-header two-factor-card-header">
            <h2><i class="fa fa-google"></i> Google Authentication</h2>
            <app-simple-badge *ngIf="highlight2fa && !isGoogleAuthEnabled" label="Recommended" color="warning"></app-simple-badge>
        </div>

        <div class="card-body" *ngIf="isLoading">
            <app-card-skeleton-loader [lineCount]="2" [lineHeight]="16"></app-card-skeleton-loader>
        </div>

        <div class="card-body" *ngIf="!isLoading">
            <div *ngIf="isGoogleAuthEnabled else enrollInGoogleAuth">
                <p>Currently enrolled.</p>
                <p>Enter the code displayed by your authenticator application when logging
                    in.</p>
            </div>
            <ng-template #enrollInGoogleAuth>
                <p *ngIf="!compact">
                    Not currently enrolled.
                </p>
                <p *ngIf="!compact || !(isMobileMode$ | async)">
                    An authenticator app lets you generate security codes on your phone without needing to receive
                    text messages.
                    If you don't already have one, we recommend Google Authenticator which you can download
                    <a href="https://apps.apple.com/us/app/google-authenticator/id388497605" target="_blank" rel="nofollow noopener">here
                        (iOS)</a> or
                    <a href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2&hl=en_US&gl=US" target="_blank" rel="nofollow noopener">here
                        (Android)</a>.
                </p>

            </ng-template>
        </div>

        <div class="card-footer d-flex justify-content-end" *ngIf="!isLoading">
            <button *ngIf="isGoogleAuthEnabled" (click)="disableGoogleAuth()" class="btn btn-outline-secondary">Disable
                Google
                Authentication
            </button>
            <button *ngIf="!isGoogleAuthEnabled" (click)="setupGoogleAuth()" class="btn btn-primary">Setup Google
                Authentication
            </button>
        </div>
    </div>

    <div class="card">
        <div class="card-header">
            <h2><i class="fa fa-commenting"></i> Text Message (SMS) Authentication</h2>
        </div>

        <div class="card-body" *ngIf="isLoading">
            <app-card-skeleton-loader [lineCount]="2" [lineHeight]="16"></app-card-skeleton-loader>
        </div>

        <div class="card-body" *ngIf="!isLoading">
            <div *ngIf="isSmsAuthEnabled else enrollInSmsAuth">
                <p>Currently enrolled.</p>
                <p>Text verification codes will be sent to the phone number ending
                    in {{this.smsLast4}}.</p>
            </div>
            <ng-template #enrollInSmsAuth>
                <p *ngIf="!compact">Not currently enrolled.</p>
                <p *ngIf="!compact || !(isMobileMode$ | async)">
                    We'll send a code via text message to a phone number you specify on each login attempt.
                </p>
            </ng-template>
        </div>

        <div class="card-footer d-flex justify-content-end" *ngIf="!isLoading">
            <button *ngIf="isSmsAuthEnabled" (click)="disableSmsAuth()" class="btn btn-outline-secondary">Disable SMS
                Authentication
            </button>
            <button *ngIf="!isSmsAuthEnabled" (click)="setupSmsAuth()" class="btn btn-primary">Setup SMS
                Authentication
            </button>
        </div>
    </div>
</div>
